import { AlertService } from '@/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { PropertiesService, RealProperty } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { PhotoUpdateDialogComponent } from '../photo-update-dialog/photo-update-dialog.component';
import { InputTrimDirective } from '../../extensions/inputTrimDirective';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgTemplateOutlet, NgIf } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

export class PropertyUpdateDialogData {
  prop: RealProperty;
}

@Component({
    selector: 'app-property-update-dialog',
    templateUrl: './property-update-dialog.component.html',
    styleUrls: ['./property-update-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, InputTrimDirective, NgIf]
})
export class PropertyUpdateDialogComponent implements OnInit, OnDestroy {
  form: UntypedFormGroup;
  dialogTitle: string;
  loading = false;

  sub = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyUpdateDialogData,
    private fb: UntypedFormBuilder,
    private propService: PropertiesService,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<PhotoUpdateDialogComponent>
  ) {
    this.dialogTitle = 'Modifier la description';
  }

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.form.get(field);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [this.data.prop.name, [Validators.required, Validators.maxLength(50)]]
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.data.prop.name = this.f('name').value;

      this.sub = this.propService.updateRealProperty(this.data.prop.uid, this.data.prop).subscribe({
        next: (result) => {
          this.dialogRef.close(true);
          this.alertService.success('Modification effectuée');
        },
        error: (err: HttpErrorResponse) => {
          this.dialogRef.close(false);
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
